<template>
    <div>
        <div :class="{'visibility-hidden' : (isModalVisible && isMobile)}">
            <loader v-if="!loaded"></loader>

            <div class="row" v-if="loaded">
                <div class="col-lg-8">
                    <div class="rotation">
                        <h4 class="rotation__title">{{'rotation.title' | trans}}</h4>
                        <p class="rotation__subtitle">{{'rotation.interactive_module_two' |
                            trans}}</p>
                        <p class="rotation__description">{{'rotation.description' |
                            trans}}</p>
                    </div>

                    <settings-form
                            v-on:session-settings-set="onSessionSettingsSet"></settings-form>

                    <div class="row mt-4" v-if="isSettingsSet">
                        <div class="col-md-12">
                            <sessions-list :sessions="sessions"
                                           v-on:show-report="onShowModalBtnClick"></sessions-list>
                        </div>
                    </div>

                </div>

                <div class="col-lg-4 mt-4 mt-lg-0">
                    <instruction :text="'rotation.instructions.text' | trans"
                                 :header="'rotation.instructions.header' | trans"
                                 :short-text-length="300">
                    </instruction>
                </div>
            </div>
            <dashboard-menu></dashboard-menu>
        </div>

        <report-modal v-if="isSettingsSet"
                      :visible="isModalVisible"
                      v-on:close="onClose"
                      v-on:cancel="onModalCancel">
        </report-modal>
    </div>
</template>

<script>
  import Loader from '../../loader/components/Loader';
  import SettingsForm from './SettingsForm';
  import Instruction from '../../../common/instruction/components/InstructionView';
  import ReportModal from './ReportModal';
  import SessionsList from './SessionsList';
  import {showModal} from '../../../common/mixins/showModal';
  import {mapActions, mapGetters, mapState} from 'vuex';
  import Manager from '../api/Manager';
  import DashboardMenu from '../../dashboardParent/components/DashboardMenu';
  import Constants from '../../dro/Constants';
  import UuidGenerator from '@/common/uuid/UuidGenerator';

  export default {
    data() {
      return {
        loaded: false,
        isSettingsSet: false,
        isModalVisible: false,
      };
    },
    mixins: [showModal],
    components: {
      Loader,
      SessionsList,
      SettingsForm,
      Instruction,
      ReportModal,
      DashboardMenu,
    },
    created() {
      this.loadInitialData();
    },
    computed: {
      ...mapState('rotation/session', [
        'stimuli',
        'sessions',
        'uuid'
      ]),
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },
    methods: {
      ...mapActions('rotation/session', [
        'setAuditor',
        'setAssignee',
        'setSettings',
        'clearSession',
        'setUuid',
      ]),
      ...mapActions('appeals', [
        'setEntity'
      ]),
      onSessionSettingsSet() {
        this.isSettingsSet = true;
        this.loaded = true;
      },
      async loadInitialData() {
        try {
          let response = await Manager.getSettings(this.route.params.clientId);
          let {stimuli, auditor, assignee} = response.data.data;
          this.clearSession();
          this.setSettings(stimuli);
          this.setAuditor(auditor);
          this.setAssignee(assignee);
          this.setUuid(UuidGenerator.v4());
          let entity = {
            id : this.uuid,
            type: Constants.ENTITY_TYPE
          };
          this.setEntity(entity);
          this.loaded = true;
        } catch (e) {
          console.error(e);
          this.$router.push({name: 'default'});
        }
      },
      onClose() {
        this.onModalClose();
        this.clearSession();
        this.$router.push({name: 'rotation', params: this.route.params});
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/randomRotation/components/SessionLayout.vue